import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import apiRequest from '../../../hooks/ApiRequest'
import Layouts from '../../Layouts'
import DocumentUploadForm from './AddEditUploadDoc'
import {toast} from 'react-toastify'
import CommonSearch from '../../../hooks/Search'

const UploadDocumentList = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [id, setID] = useState('')

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_DOCUMENT + '/DocumentMaster',
        'GET',
      )
      console.log(response?.data?.data)
      setBaseData(response?.data?.data || [])
    } catch (error) {
      console.error('Error fetching insurers', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = value => {
    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setBaseData(filterTable)
  }
  const ClearSerach = () => {
    setNationalID('')
    setBaseData(baseData)
    fetchData()
  }

  const handleCreateDoc = () => {
    setID(null)
    setModalVisible(true)
  }

  const handleEditDoc = roleId => {
    setID(roleId)
    setModalVisible(true)
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchData()
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {title: 'Create By', dataIndex: 'createdBy', key: 'createdBy'},
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              type="primary"
              className="edit_btn"
              onClick={() => handleEditDoc(record?.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => deleteDocument(record?.id)}>
            <Tooltip title="Delete">
              <Button type="danger">
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]
  const deleteDocument = async documentID => {
    const url =
      process.env.REACT_APP_BASE_URL_DOCUMENT +
      `/DocumentMaster/Delete/${documentID}`

    try {
      setLoading(true)
      const response = await apiRequest(url, 'POST')
      if (response.success) {
        toast.success('Document deleted successfully')
        fetchData()
      } else {
        toast.error(response.error || 'Failed to delete document')
      }
    } catch (error) {
      toast.error('Something went wrong while deleting. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      title="Upload Document"
      className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Upload Documents List
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <div className="item-search">
              <CommonSearch
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
                onSearch={handleSearch}
                onClear={ClearSerach}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={5} lg={4} xl={2}>
            <Button
              type="primary"
              onClick={()=>handleSearch(nationalID)}>
              Search
            </Button>
          </Col>
          <Col xs={24} sm={24} md={6} lg={4} xl={3}>
            <Button type="primary" onClick={handleCreateDoc}>
              Upload Documents
            </Button>
          </Col>
        </Row>
      </div>
      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{display: 'block', marginTop: 20}}
        />
      ) : (
        <Table columns={columns} dataSource={baseData} rowKey="id" />
      )}
      <Modal
        title="Upload Document"
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={500}>
        <DocumentUploadForm
          documentID={id}
          onSuccess={handleModalClose}
          visible={modalVisible}
        />
      </Modal>
    </div>
  )
}

export default UploadDocumentList
